module.exports = __webpack_public_path__ + "img/BG2-text.41dbcc1b.png";